<template>
  <div class="followerWrapper">
    <div class="followerContentWrapper">
      <div class="followerHeader">
        <div class="largeHeadLine">팔로워</div>
        <div class="navWrapper">
          <ul class="nav">
            <li class="navItem">
              <button class="navButton"
                      v-bind:class="{navBtnActive: selectedRouterName === 'followerInfo'}"
                      v-on:click="onclickNav('followerInfo')">팔로워</button>
            </li>
            <li class="navItem">
              <button class="navButton"
                      v-bind:class="{navBtnActive: selectedRouterName === 'followerRequest'}"
                      v-on:click="onclickNav('followerRequest')">{{'팔로워요청(' + requestCount + ')'}}</button>
            </li>
          </ul>
        </div>
      </div>
      <router-view v-on:setRequestCount="setRequestCount"></router-view>
    </div>
    <board-footer></board-footer>
  </div>
</template>

<script>
import boardFooter from '../elements/boardFooter'
import store from '../../../store'

export default {
  components: {
    'board-footer': boardFooter
  },
  data () {
    return {
      selectedRouterName: 'followerInfo',
      requestCount: 0
    }
  },
  methods: {
    onclickNav: function (type) {
      this.selectedRouterName = type
      this.$router.push({ name: type }).catch(this.catchRedundant)
    },
    catchRedundant: function (err) {
      if (
        err.name !== 'NavigationDuplicated' &&
        !err.message.includes('Avoided redundant navigation to current location')
      ) {
        console.log(err)
      }
    },
    setRequestCount: function (count) {
      this.requestCount = count
    }
  },
  created: async function () {
    let followerRequestResponse = await store.dispatch('followerRequestApi', {pageIndex: 0})
    this.requestCount = followerRequestResponse.data.data.totalElements
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../assets/css/board.css';
.followerWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  margin: 0;
  padding: 0;
  flex: 0.97;
}

.followerContentWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  height: calc(100% - 82px);
}

.followerHeader{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  padding: 0px 32px;
}

.navWrapper {
  padding: 0 10px;
}

.nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  list-style: none;
}

.navItem {
  margin-right: 40px;
}

.navButton {
  background-color: transparent;
  outline: none;
  border: none;
  margin: 0;
  padding: 0 0 5px 0;
  text-align: left;
  font-size: 13px;
  font-weight: bold;
  border-bottom: transparent 3px solid;
}

.navButton:hover{
  border-bottom-color: rgb(6,221,255);
}

.navBtnActive{
  border-bottom-color: rgb(6,221,255);
}
</style>



// WEBPACK FOOTER //
// src/components/board/views/follower.vue